import { Layout, Text } from '@loadsmart/miranda-react'

import type { StopAppointment } from 'core/appointments/domain/Appointment'
import {
  formatAppointmentStatus,
  formatAppointmentStatusColor,
} from 'core/appointments/presenters/appointmentPresenter'

export type InformationProps = {
  locationInfo: string
  dateInfo?: string
  facilityName?: string
  reserveSpace?: boolean
  appointment?: StopAppointment
}

export function Information({
  locationInfo,
  dateInfo,
  facilityName,
  reserveSpace = false,
  appointment,
}: InformationProps) {
  // non-breaking space keeps the element with vertical space when dateInfo is empty
  const nbspCharacter = '\u00A0'
  const dateInfoWithReserveSpace = dateInfo || (reserveSpace ? nbspCharacter : undefined)

  return (
    <Layout.Stack gap="spacing-1">
      {facilityName && (
        <Text variant="body-sm" color="color-text-secondary">
          {facilityName}
        </Text>
      )}
      <Text variant="body-md-bold" color="color-text-primary">
        {locationInfo}
      </Text>
      {dateInfoWithReserveSpace && (
        <Layout.Group gap="spacing-1" align="center">
          <Text variant="body-sm" color="color-text-tertiary">
            {dateInfoWithReserveSpace}
          </Text>
          {appointment?.status && (
            <>
              <Text variant="body-sm" color="color-text-tertiary">
                {'•'}
              </Text>
              <Text variant="body-sm" color={formatAppointmentStatusColor(appointment.status)}>
                {formatAppointmentStatus(appointment.status)}
              </Text>
            </>
          )}
        </Layout.Group>
      )}
    </Layout.Stack>
  )
}
